<template>
	<div
		class="d-flex align-items-center justify-content-between w-100"
		:class="floatingClass"
	>
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-40"
			>{{ label }} <span v-if="mandatory" class="asterik">*</span></label
		>
		<!-- newmodalinputbox instead of topdiv -->
		<div class="w-100">
			<div
				class="date-floating-label"
				:class="
					from == 'kanban' ? 'newmodalinputbox position-relative' : 'topDiv'
				"
				@mouseover="hovering = true"
				@mouseleave="hovering = false"
			>
				<!-- nothing except w-100 n pointer -->
				<DatePicker
					ref="date"
					class="w-100"
					:class="{
						'datefield-input': from != 'kanban',
						dateerror: showError,
						pointer: !disabled,
					}"
					:placeholder="placeholder"
					:format="format"
					:value-type="format"
					:type="datetype"
					v-model="inputData"
					:editable="false"
					:show-second="false"
					:disabled-date="disabledDates"
					:disabled="disabled"
					:minute-step="minuteInterval"
					:disabled-time="disableBeforeTime"
					@focus="handleFocus"
					@blur="handleBlur"
					@input="$emit('select-value', inputData)"
					:append-to-body="false"
				/>
				<img
					v-if="(hovering || !isLaptop) && inputData && !disabled"
					@click="clearInputData"
					:class="
						id.startsWith('slot') ? 'slot-clear-icon' : 'close-icon-class'
					"
					class="pointer"
					src="../../assets/newdesign/inputcomponent/date-x-close.svg"
					alt=""
				/>
				<img
					v-if="icon == 'time'"
					@click="openDatePicker"
					class="kanban-calendar-icons pointer"
					src="../../assets/newdesign/inputcomponent/Time.svg"
					alt=""
				/>
				<img
					:class="
						from == 'kanban' ? 'kanban-calendar-icons' : 'new-calender-class'
					"
					v-else-if="!id.startsWith('slot')"
					@click="openDatePicker"
					class="pointer"
					src="../../assets/newdesign/inputcomponent/new-calender-icon.svg"
					alt=""
				/>
				<label id="hideinlaptop" :class="{ active: isFocused || inputData }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "DateField",
	data() {
		return {
			isLaptop: true,
			inputData: "",
			hovering: false,
			isFocused: false,
			minuteInterval: 1,
		};
	},
	props: {
		noLabel: Boolean,
		disabled: Boolean,
		type: String,
		label: String,
		mandatory: Boolean,
		placeholder: String,
		id: String,
		showError: Boolean,
		format: String,
		startDate: String,
		from: String,
		icon: String,
		minuteStep: Number,
		startTime: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	mounted() {
		document.addEventListener("click", this.handleClick);
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	beforeDestroy() {
		document.removeEventListener("click", this.handleClick);
	},
	watch: {
		vmodel(newValue) {
			console.log(newValue, "newValllllllllll");

			if (this.id == "dateOfBirth") {
				let value = newValue.slice(0, 10);
				if (this.isYYYMMDDFormat(value)) {
					value = this.convertDate(value);
					this.inputData = value;
				}
			} else {
				this.inputData = newValue;
			}
			this.$emit("select-value", this.inputData);
		},
		startDate(newValue) {
			console.log(
				"88888888888888888888888888888888888888888888888888888888888888888"
			);

			console.log(newValue, "ffffffffffffffffffffffffff");
		},
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
		datetype() {
			if (
				this.format === "MM-DD-YYYY" ||
				this.format === "DD-MM-YYYY" ||
				this.format === "YYYY-MM-DD"
			) {
				return "date";
			} else if (
				this.format === "DD-MM-YYYY HH:mm:ss" ||
				this.format === "MM-DD-YYYY HH:mm:ss"
			) {
				return "datetime";
			} else if (this.format === "MM-YYYY" || this.format == "YYYY-MM") {
				return "month";
			} else if (this.format === "YYYY") {
				return "year";
			} else if (
				this.format === "HH:mm:ss" ||
				this.format === "HH:mm" ||
				this.format === "hh:mm a"
			) {
				return "time";
			}
			return "date";
		},
		floatingClass() {
			return this.id === "yearOfPassout" || this.id === "yearOfJoining"
				? ""
				: "ontop";
		},
	},
	created() {
		if (this.vmodel && this.id == "dateOfBirth") {
			this.inputData = this.convertDate(this.vmodel.slice(0, 10));
		} else if (this.vmodel) {
			this.inputData = this.vmodel;
		}
		if (this.id == "slot-startTime" || this.id == "slot-endTime")
			this.minuteInterval = this.minuteStep;
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		handleClick(event) {
			let minutePicker = document.querySelector('[data-type="minute"]');
			let datePickerContainer =
				document.getElementsByClassName("mx-datepicker-main")[0];
			if (minutePicker?.contains(event.target)) {
				datePickerContainer.style.display = "none";
			} else if (datePickerContainer) {
				datePickerContainer.style.display = "";
			}
		},
		handleFocus() {
			this.isFocused = true;
		},
		handleBlur() {
			this.isFocused = !!this.inputData;
		},
		openDatePicker() {
			this.$refs.date.$el.children[0].click();
		},
		clearInputData() {
			this.inputData = "";
			this.$emit("select-value", this.inputData);
		},
		convertDate(date) {
			const [year, month, day] = date.split("-");
			return `${day}-${month}-${year}`;
		},
		isYYYMMDDFormat(dateStr) {
			// Regular expression to check if the date is in yyyy-mm-dd format
			const regex = /^\d{4}-\d{2}-\d{2}$/;
			return regex.test(dateStr);
		},
		disabledDates(date) {
			const today = new Date();
			if (
				this.id == "from-date" ||
				this.id == "issueDate" ||
				this.id == "dateOfBirth"
			) {
				// Function to disable dates in the future
				return date > today;
			} else if (this.id == "yearOfJoining" || this.id == "startDate") {
				const dateOfBirth = new Date(this.candidateInfo.dateOfBirth);
				console.log(dateOfBirth, "dateeeeeeeeeee");

				return date > today || date < dateOfBirth;
			} else if (this.id == "to-date") {
				if (this.startDate) {
					const startDate = new Date(this.startDate);
					// Disable dates before startDate and after today
					return date <= startDate || date > today;
				} else {
					// Disable dates after today
					return date > today;
				}
			} else if (this.id === "yearOfPassout" || this.id === "endDate") {
				if (this.startDate) {
					const startDate = new Date(this.startDate);
					// Disable dates before startDate or after today
					return date <= startDate || date > today;
				} else if (this.id === "endDate" && this.mandatory) {
					// Disable dates after today
					return date > today;
				} else if (!this.mandatory && this.id === "endDate") {
					// Allow all dates
					return false;
				}
			} else if (this.id === "to-and-from") {
				// Enable current date and future dates
				const selectedDate = new Date(date).toDateString();
				const formattedToday = today.toDateString();
				return new Date(selectedDate) < new Date(formattedToday);
			}

			// Default case: No restriction
			return null;
		},
		disableBeforeTime(date) {
			if (this.id == "slot-endTime") {
				if (!this.startTime) return false;
				const [time, period] = this.startTime.split(" ");
				let [minHour, minMinutes] = time.split(":").map(Number);
				if (period.toLowerCase() === "pm" && minHour !== 12) {
					minHour += 12; // Convert PM to 24-hour format
				}
				if (period.toLowerCase() === "am" && minHour === 12) {
					minHour = 0; // Midnight case (12 AM = 00:00)
				}
				// Add 30 minutes to the startTime
				minMinutes += 30;
				if (minMinutes >= 60) {
					minMinutes -= 60;
					minHour += 1;
				}
				const selectedHour = date.getHours();
				const selectedMinutes = date.getMinutes();
				return (
					selectedHour < minHour ||
					(selectedHour === minHour && selectedMinutes < minMinutes)
				);
			}
			return null;
		},
	},
};
</script>

<style>
.slot-clear-icon {
	position: absolute;
	right: 4px;
	top: 11px;
}
.datefield-input > .mx-input-wrapper > .mx-icon-calendar {
	display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear {
	display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear:hover {
	display: none;
}

.mx-input-wrapper input::placeholder {
	color: #667085;
}

.topDiv > .dateerror .mx-input {
	border: 1px solid red !important;
	border-radius: 8px !important;
}
.topDiv > .datefield-input .mx-input {
	cursor: pointer;
}
.newmodalinputbox > .dateerror .mx-input {
	border: 1px solid red !important;
	border-radius: 8px !important;
}
.newmodalinputbox > .datefield-input .mx-input {
	cursor: pointer;
}

.new-calender-class {
	position: absolute;
	right: 15px;
	top: 12px;
}

.close-icon-class {
	position: absolute;
	right: 42px;
	top: 12px;
}

.topDiv > .datefield-input .mx-input:disabled {
	background: #f7f7f7 !important;
	cursor: default;
}
.date-floating-label label {
	position: absolute;
	left: 10px;
	top: 10px;
	font-size: 12px;
	color: #667085;
	font-weight: 400;
	font-family: "Lato", sans-serif;
	transition: all 0.2s ease;
	pointer-events: none;
}

.date-floating-label label.active {
	top: -10px;
	left: 13px;
	font-size: 13px;
	color: #667085;
	font-weight: 400;
	font-family: "Lato", sans-serif;
	background-color: #ffffff;
}

@media (min-width: 1029px) {
	#formsmodal .ontop .mx-datepicker-main {
		top: 40px !important;
	}
}
@media (max-width: 1028px) {
	.mx-input::placeholder {
		color: #ffffff !important;
	}
}
#slotprefsmodal .mx-time-column .mx-time-list::after {
	height: 0px;
}
</style>
